<template>
  <div :class="$style.page">
    <Title title="资金提现" mode="margin">
      <template v-slot:actions>
        <span :class="$style.btn_back" @click="goBack">返回</span>
      </template>
    </Title>

    <div :class="$style.tips">
      <p :class="$style.tips_title">请仔细阅读以下内容：</p>
      <p>
        1、银行卡账号主要用来充值或者提现使用，您添加输入与您身份证姓名一致的绑定银行卡号，否则提现审核失败!。
      </p>
      <p>
        2、如充值遇到问题请拨打客服电话：
        <span class="theme-color">400-0823-818</span>
      </p>
    </div>

    <div :class="$style.info">
      账户可用金额：
      <span :class="$style.balance">{{ amountInfo.balance }}</span>
      元
    </div>

    <Item title="提现金额">
      <el-input v-model="amount" @input="onAmountChange"></el-input>
      <span :class="$style.desc">
        元，<span :class="$style.btn_blue" @click="withdrawAllCash">
          全部提现
        </span>
        提现手续费：<span>{{ serviceMoney }} </span>
      </span>
    </Item>

    <Item title="提现账号">
      <el-select v-model="bankValue" @change="onCardChange">
        <el-option
          v-for="item in cardList"
          :key="item.id"
          :label="`${item.bankName}-${item.cardNumber}`"
          :value="item.id"
        />
      </el-select>
      <span :class="$style.btn_blue" @click="setVisible1(true)">
        + 新增银行卡
      </span>
      <span :class="$style.btn_blue" @click="setVisible2(true)">
        我的银行卡
      </span>
    </Item>

    <Item title=" ">
      <Button type="primary" @click="submit">申请提现</Button>
    </Item>

    <Divider :class="$style.divider" />

    <Title title="提现记录" :count="total" />

    <el-table
      ref="multipleTable"
      :data="showList"
      :fit="true"
      border
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        prop="createdTime"
        label="提现日期"
        width="80"
        align="center"
      />

      <el-table-column
        prop="bankName"
        label="提现银行"
        width="120"
        align="center"
      />

      <el-table-column
        prop="cardNo"
        label="提现账号（后4位）"
        width="120"
        align="center"
      />

      <el-table-column
        prop="payable"
        label="提现金额"
        width="120"
        align="center"
      >
      </el-table-column>

      <el-table-column label="提现状态" width="120" align="center">
        <template slot-scope="scope">
          {{ mapStatus[scope.row.status] || "用户取消" }}
          <span
            v-if="scope.row.status === 0"
            :class="$style.btn_cancel"
            @click="cancelApply(scope.row.id)"
          >
            取消申请
          </span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="page"
      :page-size="limit"
      :total="total"
      @current-change="handlePageChange"
    />

    <!-- 添加银行卡弹窗 -->
    <AddBankPopup :visible="visible1" @close="setVisible1(false)" />

    <!-- 我的银行卡列表弹窗 -->
    <MyBankPopup :visible="visible2" @close="setVisible2(false)" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import Tools from "@/utils/tools";
import { accMul } from "@utils/multiplication";
import {
  getLevel,
  getBankCard,
  getWithdrawalRecord,
  createWithdrawal,
  deleteWithdrawal,
} from "@server";

import AddBankPopup from "./with-drawal/AddBankPopup.vue";
import MyBankPopup from "./with-drawal/MyBankPopup.vue";

export default {
  name: "WithDrawal",
  components: { AddBankPopup, MyBankPopup },
  data() {
    return {
      amount: "",
      serviceCharge: "0.00", // 手续费
      cardList: [],
      bankValue: "", // 银行卡
      banKLabel: "", //
      levelRatio: 0.01, // 手续费(默认 1%)

      page: 1,
      limit: 20,
      showList: [],
      total: 0,

      mapStatus: {
        0: "待审核",
        1: "待转账",
        2: "转账成功",
        3: "转账失败",
        4: "审核失败",
      },

      visible1: false,
      visible2: false,
    };
  },
  computed: {
    ...mapState("user", ["amountInfo"]),

    serviceMoney() {
      if (
        this.levelRatio != null &&
        this.amount != null &&
        this.amount != "" &&
        !isNaN(this.amount)
      ) {
        return accMul(this.amount, this.levelRatio) + "元";
      } else {
        return "";
      }
    },
  },
  methods: {
    ...mapActions("user", ["getAmountInfoAction"]),

    async getLevel() {
      const res = await getLevel();
      if (res.code == 200) {
        this.levelRatio = res.data.depositRate * 0.01;
      }
    },
    async getBankCard() {
      const params = {
        page: this.page,
        limit: this.limit,
      };
      const res = await getBankCard(params);
      if (res.code == 200) {
        this.cardList = res.data.list;
      }
    },
    async searchRecord(page = 1) {
      this.page = page;
      const params = {
        page,
        limit: this.limit,
      };
      const res = await getWithdrawalRecord(params);
      if (res.code === 200) {
        this.showList = res.data.list;
        this.total = res.data.total;
      }
    },
    checkSubmit() {
      if (this.amountInfo.balance <= 0) {
        this.$message({ message: "当前账户没有可用金额!", type: "warning" });
        return false;
      }
      if (!this.amount) {
        this.$message({ message: "请输入提现金额!", type: "warning" });
        return false;
      }
      if (!this.bankValue) {
        this.$message({ message: "请选择银行账号!", type: "warning" });
        return false;
      }

      return true;
    },
    async submit() {
      if (!this.checkSubmit()) return;

      const text = `确定要提现 ${this.amount} 元至${this.banKLabel}吗？手续费 ${this.serviceMoney} 元`;
      this.$confirm(text, "提现确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          const data = {
            bankCardId: this.bankValue,
            amount: this.amount,
          };
          const res = await createWithdrawal(data);
          if (res.code === 200) {
            this.$message({ message: "提现成功!", type: "success" });
            this.money = "";
            this.bankValue = "";
            this.banKLabel = "";
            this.searchRecord();
            this.getAmountInfoAction();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
          this.loading = false;
        })
        .catch(() => {});
    },
    cancelApply(id) {
      this.$confirm("确定要取消此提现申请吗？", "取消确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteWithdrawal(id);

          if (res.code === 200) {
            this.$message({ message: "取消成功！!", type: "success" });
            this.searchRecord();
            this.getAmountInfoAction();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        })
        .catch(() => {});
    },

    goBack() {
      this.$router.back();
    },

    // 数值改变
    onAmountChange() {
      if (this.amount == null) return;
      var amount = this.amount.replace(/[^\d.]/g, "");
      if (/^(\.)$/.test(amount)) {
        amount = "0.";
      }
      if (/^(\d?)+(\.\d{0,2})?$/.test(amount)) {
        //正则验证，提现金额小数点后不能大于两位数字
        if (/^(0[0]*)$/.test(amount)) {
          this.amount = amount.replace(/^(0*)/g, "0");
        } else if (/^(0[1-9]*)$/.test(amount)) {
          this.amount = amount.replace(/^(0*)/g, "");
        } else {
          this.amount = amount;
        }
      } else {
        this.amount = amount.substring(0, amount.length - 1);
      }
    },

    onCardChange(value) {
      const item = this.cardList.find((i) => (i.id = value));
      this.banKLabel = item.label;
    },
    withdrawAllCash() {
      const _balance = this.amountInfo.balance;
      if (_balance <= 0) {
        this.$message({ message: "当前账户没有可用金额!", type: "warning" });
        return;
      }
      this.amount = _balance;
    },

    handlePageChange(page) {
      this.searchRecord(page);
    },

    setVisible1(v) {
      this.visible1 = v;
    },

    setVisible2(v) {
      this.visible2 = v;
    },
  },
  created() {
    this.getLevel();
    this.getBankCard();
    this.searchRecord();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 300px;
  padding: rem(50);
  font-size: rem(16);
  color: #333;
  background: $white;
  box-shadow: $box-shadow;

  :global {
    ::v-deep.gl-item {
      padding-bottom: rem(40);
    }

    .el-select {
      ::v-deep .el-input {
        width: rem(360);
        margin-right: rem(20);
      }
    }

    .el-input {
      width: 160px;
      margin-right: rem(20);
    }

    .el-pagination {
      @include flex();
      margin-top: rem(50);
    }
  }

  .btn_back {
    padding: 5px;
    font-size: rem(14);
    color: #333;
    cursor: pointer;
    &:hover {
      color: $theme-color;
    }
  }

  .title {
    font-size: max(rem(18), 16px);
    color: #333;
    font-weight: bold;
  }

  .tips {
    padding: rem(30) rem(50);
    margin-bottom: rem(40);
    font-size: rem(14);
    color: #333;
    line-height: 30px;
    background: #f6f6f9;

    .tips_title {
      font-weight: bold;
    }
  }

  .info {
    font-size: rem(14);
    color: #333;
    margin-right: 64px;
    margin-bottom: rem(40);

    .balance {
      color: $theme-color;
      font-weight: bold;
    }
  }

  .balance {
    color: $theme-color;
    font-weight: bold;
  }

  .desc {
    font-size: rem(14);
    color: #333;
  }

  .btn_blue,
  .btn_cancel {
    margin-right: rem(30);
    font-size: rem(14);
    color: $theme-blue-color;
    user-select: none;
    cursor: pointer;
  }

  .btn_cancel {
    margin-left: rem(20);
  }
}
</style>
